<div class="network">
  <div class="sidenav">
    <div class="list">
      <div class="search">
        <div class="searchbar">
          <div class="bar">
            <app-celo-topbar-search-input
              class="fw"
              [searchTerm]="searchTerm"
              [placeholder]="'Search the network'"
              (doSearch)="search($event)"
            >
            </app-celo-topbar-search-input>
          </div>
          <div
            class="celo-open-horizontal cancel"
            [style.width.px]="searchTerm ? 100 : 0"
          >
            <button
              class="celo-primary-button-blue celo-hoverable m-1"
              mat-button
              (click)="search('')"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      @if (searchTerm) {
        <div class="search-results">
          <div class="sidenav-padding">
            <app-search-result
              [searchNow$]="searchNow$"
              [discoverable]="discoverable"
              [selectable]="false"
              [page_type]="'new_chat'"
              [hideConnections]="false"
              [hideNetwork]="false"
              [myWorkspacesAndPartnerWorkspaceIds]="
                myWorkspacesAndPartnerWorkspaceIds
              "
              [userAccount]="userAccount"
              (contactClick)="onSearchContactClick($event)"
              (roleClick)="handleRoleClicked($event)"
              [workspaces]="allWorkspaces"
            ></app-search-result>
          </div>
        </div>
      }
    </div>
    <div [ngClass]="{ hidden: searchTerm }">
      <div class="list">
        <div class="title">
          <div class="text">My Workspaces</div>
          @if (myWorkspaces && myWorkspaces.length && canCreateWorkspace) {
            <a (click)="onAddAWorspaceClicked()" class="celo-link add-workspace"
              >Add a workspace</a
            >
          }
        </div>
        @if ((!myWorkspaces || !myWorkspaces.length) && canCreateWorkspace) {
          <a
            (click)="onAddAWorspaceClicked()"
            class="celo-link add-workspace sidenav-padding"
            >Add a workspace</a
          >
        }
        <ul>
          @for (
            workspace of myWorkspaces;
            track workspace;
            let index = $index
          ) {
            <li
              [routerLink]="['/network/workspace', workspace.id]"
              [routerLinkActive]="['selected-workspace']"
              (click)="
                raiseWorkspaceClickEvent(index + 1 > visibleWorkspaceCount)
              "
            >
              @if (showAllWorkspaces || index < visibleWorkspaceCount) {
                <div class="workspace-name celo-hoverable">
                  <div>{{ workspace.name }}</div>
                </div>
              }
            </li>
          }
        </ul>
        @if (
          showAllWorkspaces && partneredWorkspaces && partneredWorkspaces.length
        ) {
          <div class="title">
            <div class="text">Partner Workspaces</div>
          </div>
        }
        <ul>
          @for (
            workspace of partneredWorkspaces;
            track workspace;
            let index = $index
          ) {
            <li
              [routerLink]="['/network/workspace', workspace.id]"
              [routerLinkActive]="['selected-workspace']"
              (click)="raiseWorkspaceClickEvent(true)"
            >
              @if (showAllWorkspaces) {
                <div class="workspace-name celo-hoverable">
                  <div>{{ workspace.name }}</div>
                </div>
              }
            </li>
          }
        </ul>
        @if (
          (partneredWorkspaces && partneredWorkspaces.length) ||
          (myWorkspaces && myWorkspaces.length > visibleWorkspaceCount)
        ) {
          <div class="sidenav-padding">
            <a class="celo-link" (click)="toggleShowAll()">
              @if (!showAllWorkspaces) {
                <span>Show more workspaces</span>
              }
              @if (showAllWorkspaces) {
                <span>Show less workspaces</span>
              }
            </a>
          </div>
        }
      </div>
      <div class="list">
        <div class="title">
          <div class="text">Connections</div>
          @if (connectionsCount) {
            <a (click)="addConnections()" class="celo-link add-workspace"
              >Add connections</a
            >
          }
        </div>
        <app-connections-list
          (connectionsLoaded)="connectionsCount = $event"
        ></app-connections-list>
        @if (connectionsCount === 0) {
          <div
            matRipple
            class="connections-empty-state celo-hoverable celo-cursor-pointer"
            (click)="addConnections()"
          >
            <div class="image">
              <img
                src="../../../../assets/ctas/cta-add-your-colleagues.svg"
                alt=""
              />
            </div>
            <div class="texts">
              <div class="connections-title">Add connections</div>
              <div class="connections-subtitle">
                Connect with your colleagues to start a conversation
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
    @if (!isContactsRoute) {
      @if (userHasNoWorkpaces) {
        <div class="empty-state">
          <app-workspace-empty-state></app-workspace-empty-state>
        </div>
      }
      @if (!workspaceInfoLoaded) {
        <div class="empty-state">
          <app-empty-state
            [spinner]="true"
            [animation]="false"
            [isLoading]="true"
            [message]="' '"
            [diameter]="16"
            [stroke]="2"
          ></app-empty-state>
        </div>
      }
    }
  </div>
</div>
